import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import { useMutation, useQueryClient } from "react-query";
import createCache from "@emotion/cache";
import { createStyles, makeStyles } from "@material-ui/core";
import { Box, Button, FormControl, Grid, Tooltip } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { createTheme } from "@mui/material/styles";
import { Formik } from "formik";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { TABLE_FILTER } from "../../config/cacheKey";
import {
  GetCheques,
  GetChequesExportToExcel,
} from "../../services/cheque.service";
import { convertToLocalDateTime } from "../../utility/dateUtility";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import PriceFeildComponent from "../../components/priceFeild/priceFeildComponent";
import DatePickerComponents from "../../components/datePicker/DatePickerComponents";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import ChipCmp from "../../components/chip/chipCmp";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../models/common.model";
import {
  Filter,
  GetSuccessfullPaymentsRequest,
  GetSuccessfullPaymentsResponse,
  PaginationInfo,
} from "../../models/payment.model";
import {
  GetSuccessfullPayments,
  GetSuccessfullPaymentsExcel,
} from "../../services/payment.service";

const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
  );
};

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const columns: readonly ColumnModel[] = [
  { id: "customerName", label: "متقاضی" },
  { id: "customerNationalCode", label: "کدملی" },
  {
    id: "loanTemplateTitle",
    label: " طرح تسهیلات",
  },
  {
    id: "organizationTitle",
    label: " سازمان ",
  },
  { id: "referenceKey", label: "شناسه تسهیلات" },
  {
    id: "paymentAmountRial",
    label: " مبلغ پرداختی (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value?.toLocaleString("fa");
    },
  },
  {
    id: "paymentDatePersian",
    label: "تاریخ پرداخت",
  },
  {
    id: "traceNumber",
    label: "کد رهگیری",
  },
  {
    id: "paymentStateTitle",
    label: "وضعیت پرداخت",
  },
  {
    id: "gateway",
    label: "درگاه پرداخت",
  },
  {
    id: "transactionCode",
    label: "کد تراکنش",
  },
];
let muiSelected: any;

export default function DisagreementReport() {
  const jsonFile = useSelector((state: any) => state.style);
  const useStyles = makeStyles((theme) =>
    createStyles({
      select: {
        "&.Mui-selected": {
          backgroundColor: muiSelected + "!important",
        },
      },
    })
  );
  const classes = useStyles();
  const [valueFilterData, setValueFilterData] = React.useState<Filter>();
  const [
    valuePaymentAmountInRialFrom,
    setValuePaymentAmountInRialFrom,
  ] = useState<number | undefined>();
  const [valuePaymentAmountInRialTo, setValuePaymentAmountInRialTo] = useState<
    number | undefined
  >();
  const [paymentDate, setPaymentDate] = useState<Date[] | null | undefined>(
    null
  );
  const [valuePaymentDate, setValuePaymentDate] = useState<string>();
  const [
    valueCustomerNationalCode,
    setValueCustomerNationalCode,
  ] = React.useState<string>();
  const [valueCustomerName, setValueCustomerName] = React.useState<string>();
  const [valueReferenceKey, setValueReferenceKey] = React.useState<string>();
  const [referenceKey, setReferenceKey] = React.useState<string>();
  const removeNonNumeric = (num: any) => num?.toString().replace(/[^0-9]/g, "");
  const queryClient = useQueryClient();
  const history = useHistory<{
    from: string;
    id: number;
    pageNumber: number;
    clickOnBack: boolean;
    saleKey: string;
    branchId: number;
    customerPersonId: number;
  }>();
  const [data, setData] = useState<GetSuccessfullPaymentsResponse[]>([]);
  const previousPage =
    history.location.state !== undefined ? history.location.state.from : null;
  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber =
        history.location.state != undefined
          ? history.location.state.pageNumber
          : 1;
      return paginationInfo;
    }
  );

  React.useEffect(() => {
    let filterData;
    if (
      previousPage !== null ||
      (history.action === "REPLACE" &&
        history.location.state !== undefined &&
        history.location.state.clickOnBack)
    ) {
      filterData = queryClient.getQueryData<Filter>(TABLE_FILTER);
      if (filterData !== undefined && filterData !== null) {
        setValuePaymentAmountInRialFrom(filterData!.paymentAmountInRialFrom!);
        setValuePaymentAmountInRialTo(filterData!.paymentAmountInRialTo!);
        setValuePaymentDate("");
        setValueCustomerNationalCode(filterData!.customerNationalCode!);
        setValueCustomerName(filterData!.customerName!);
        setValueReferenceKey(filterData!.referenceKey!);
        setValueFilterData(filterData);
      }
    } else {
      filterData = null;
      let filter = new Filter();
      queryClient.setQueryData(TABLE_FILTER, filter);
      filter.paymentAmountInRialFrom = undefined;
      filter.paymentAmountInRialTo = undefined;
      filter.paymentDateFrom = undefined;
      filter.paymentDateTo = undefined;
      filter.customerNationalCode = undefined;
      filter.customerName = undefined;
      filter.referenceKey = undefined;
      setValueFilterData(filter);
    }
    fillData(filterData!);
  }, []);

  const GetSuccessfullPaymentsExcelMutate = useMutation(
    GetSuccessfullPaymentsExcel,
    {
      onSuccess: (result) => {},
      onError: (e) => {},
    }
  );

  const { mutateAsync: GetSuccessfullPaymentsMutate } = useMutation(
    GetSuccessfullPayments,
    {
      onSuccess: (data: ApiResultModel<GetSuccessfullPaymentsResponse[]>) => {
        setData(data.data);
        setPageInfo(data.pageInfo);
      },
    }
  );
  const generateFilter = (
    filterData: Filter
  ): GetSuccessfullPaymentsRequest => {
    let request = {} as GetSuccessfullPaymentsRequest;
    request.paginationInfo = currentPaginationInfo;
    request.filter = filterData;
    return request;
  };

  const fillData = (filterData: Filter) => {
    let filter = generateFilter(filterData);
    GetSuccessfullPaymentsMutate(filter);
    setValueFilterData(filter?.filter);
  };

  const changePageNumber = (newPageNumber: number) => {
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    fillData(tabelFilter!);
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
  };

  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
  };

  function deleteChip() {
    setValuePaymentAmountInRialFrom(undefined);
    setValuePaymentAmountInRialTo(undefined);
    setValuePaymentDate(undefined);
    setValueCustomerNationalCode(undefined);
    setValueCustomerName(undefined);
    setValueReferenceKey(undefined);
    setReferenceKey("");
    let filter = new Filter();
    queryClient.setQueryData(TABLE_FILTER, filter);
    fillData(queryClient.getQueryData(TABLE_FILTER)!);
    currentPaginationInfo.pageNumber = 1;
    setCurrentPaginationInfo(currentPaginationInfo);
  }
  const filter = new Filter();
  const [isShow, setIsShow] = useState(true);
  let handelFilter = () => {
    setIsShow(!isShow);
  };

  let exportExcel = () => {
    GetSuccessfullPaymentsExcelMutate.mutate(
      valueFilterData ? valueFilterData! : new Filter()
    );
  };

  const setChildValuePaymentAmountInRialFrom = (childValues: any) => {
    setValuePaymentAmountInRialFrom(undefined);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter !== undefined)
      tabelFilter!.paymentAmountInRialFrom = undefined;
    fillData(tabelFilter!);
  };
  const setChildValuePaymentAmountInRialTo = (childValues: any) => {
    setValuePaymentAmountInRialTo(undefined);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter !== undefined)
      tabelFilter!.paymentAmountInRialTo = undefined;
    fillData(tabelFilter!);
  };
  const setChildValuePaymentDate = (childValues: any) => {
    setValuePaymentDate("");
    setPaymentDate(undefined);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter !== undefined) {
      tabelFilter!.paymentDateFrom = undefined;
      tabelFilter!.paymentDateTo = undefined;
    }
    fillData(tabelFilter!);
  };

  const setChildValueCustomerNationalCode = (childValues: any) => {
    setValueCustomerNationalCode("");
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter !== undefined)
      tabelFilter!.customerNationalCode = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueCustomerName = (childValues: any) => {
    setValueCustomerName("");
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter !== undefined) tabelFilter!.customerName = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueReferenceKey = (childValues: any) => {
    setValueReferenceKey(undefined);
    setReferenceKey("");
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter !== undefined) tabelFilter!.referenceKey = undefined;
    fillData(tabelFilter!);
  };

  function changeValuePaymentAmountInRialFrom(e: any) {
    setValuePaymentAmountInRialFrom(
      removeNonNumeric(e.currentTarget.value).replace(/,/g, "")
    );
  }
  function changeValuePaymentAmountInRialTo(e: any) {
    setValuePaymentAmountInRialTo(
      removeNonNumeric(e.currentTarget.value).replace(/,/g, "")
    );
  }
  function changeValuePaymentDate(e: any) {
    setPaymentDate(e);
    setValuePaymentDate(e.toString().replace(/,/g, " - "));
  }
  function changeValueCustomerNationalCode(e: any) {
    setValueCustomerNationalCode(e.currentTarget?.value);
  }
  function changeValueCustomerName(e: any) {
    setValueCustomerName(e.currentTarget?.value);
  }
  function changeValueReferenceKey(e: any) {
    setValueReferenceKey(e.currentTarget?.value);
    setReferenceKey(e.currentTarget?.value);
  }
  return (
    <div>
      <Tooltip title="فیلتر" arrow>
        <img
          onClick={handelFilter}
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src="images/filter.png"
        />
      </Tooltip>
      <span style={{ margin: "2vh", color: "#CFD8DC" }}>|</span>
      <Tooltip title="خروجی اکسل" arrow>
        <img
          onClick={exportExcel}
          className="cursorPointer"
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src="images/ExportXLS.svg"
        />
      </Tooltip>
      {isShow ? (
        <Box sx={{ flexGrow: 1 }}>
          <Formik
            initialValues={filter}
            onSubmit={(values: any) => {
              if (
                paymentDate != null &&
                (paymentDate[0] !== undefined || paymentDate[1] !== undefined)
              ) {
                values.paymentDateFrom = convertToLocalDateTime(
                  Number(paymentDate[0])
                );
                if (paymentDate.length > 1) {
                  values.paymentDateTo = convertToLocalDateTime(
                    Number(paymentDate[1])
                  );
                } else {
                  values.paymentDateTo = convertToLocalDateTime(
                    Number(paymentDate[0])
                  );
                }
              } else {
                values.paymentDateFrom = undefined;
                values.paymentDateTo = undefined;
                values.paymentDate = undefined;
              }
              values.paymentAmountInRialFrom = valuePaymentAmountInRialFrom;
              values.paymentAmountInRialTo = valuePaymentAmountInRialTo;
              values.customerNationalCode = valueCustomerNationalCode;
              values.customerName = valueCustomerName;
              values.referenceKey = valueReferenceKey;
              // values.paymentDate = valuePaymentDate;
              queryClient.setQueryData(TABLE_FILTER, values);
              fillData(values);
              currentPaginationInfo.pageNumber = 1;
              setCurrentPaginationInfo(currentPaginationInfo);
            }}
          >
            {({ handleSubmit, handleChange, values }) => (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      helperText={""}
                      placeHolder={"متقاضی"}
                      label={"متقاضی"}
                      required={false}
                      value={valueCustomerName}
                      onChange={changeValueCustomerName}
                      name="customerName"
                      id="customerName"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      helperText={""}
                      placeHolder={"کدملی"}
                      label={"کدملی"}
                      required={false}
                      value={valueCustomerNationalCode}
                      onChange={changeValueCustomerNationalCode}
                      name="customerNationalCode"
                      id="customerNationalCode"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      helperText={""}
                      placeHolder={"شناسه تسهیلات"}
                      label={"شناسه تسهیلات"}
                      required={false}
                      value={referenceKey}
                      onChange={changeValueReferenceKey}
                      name="referenceKey"
                      id="referenceKey"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <PriceFeildComponent
                          placeHolder={"مبلغ پرداختی از (ریال)"}
                          label={"مبلغ پرداختی از (ریال)"}
                          required={false}
                          value={valuePaymentAmountInRialFrom ?? ""}
                          onChange={changeValuePaymentAmountInRialFrom}
                          name="paymentAmountInRialFrom"
                          id="paymentAmountInRialFrom"
                          showPersianWords={false}
                        />
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <PriceFeildComponent
                          helperText={""}
                          placeHolder={"مبلغ پرداختی تا (ریال)"}
                          label={"مبلغ پرداختی تا (ریال)"}
                          required={false}
                          value={valuePaymentAmountInRialTo ?? ""}
                          onChange={changeValuePaymentAmountInRialTo}
                          name="paymentAmountInRialTo"
                          id="paymentAmountInRialTo"
                          showPersianWords={false}
                        />
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <FormControl fullWidth className="shadowDatepicker">
                      <DatePickerComponents
                        valueArray={paymentDate}
                        label={"تاریخ پرداخت"}
                        onChange={changeValuePaymentDate}
                        range={true}
                      />
                    </FormControl>
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter"
                    style={{ paddingTop: "1vh" }}
                  >
                    <Button
                      fullWidth
                      variant="contained"
                      type="submit"
                      className="btnForm SuccessDefault  "
                    >
                      اعمال فیلتر
                    </Button>
                  </div>
                </div>

                {valuePaymentAmountInRialFrom ||
                valuePaymentAmountInRialTo ||
                valuePaymentDate ||
                valueCustomerNationalCode ||
                valueCustomerName ||
                valueReferenceKey ? (
                  <div className="row tableCMP">
                    <Grid container xs={12}>
                      <Grid item xs={12} sm={0.5} style={{ marginTop: "20px" }}>
                        <Button
                          onClick={deleteChip}
                          style={{
                            justifyContent: "right",
                            minWidth: "25px",
                            marginRight: "-1vh",
                          }}
                        >
                          <img
                            style={{ height: "24px", width: "24px" }}
                            src="images/RemoveAllFilters.svg"
                          />
                        </Button>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={11.5}
                        style={{ marginTop: "10px" }}
                      >
                        <ChipCmp
                          item={valuePaymentAmountInRialFrom}
                          enamValue={valuePaymentAmountInRialFrom}
                          index={valuePaymentAmountInRialFrom}
                          setChildValue={setChildValuePaymentAmountInRialFrom}
                        />
                        <ChipCmp
                          item={valuePaymentAmountInRialTo}
                          enamValue={valuePaymentAmountInRialTo}
                          index={valuePaymentAmountInRialTo}
                          setChildValue={setChildValuePaymentAmountInRialTo}
                        />
                        <ChipCmp
                          item={valuePaymentDate}
                          enamValue={valuePaymentDate}
                          index={valuePaymentDate?.length}
                          setChildValue={setChildValuePaymentDate}
                        />
                        <ChipCmp
                          item={valueCustomerNationalCode}
                          enamValue={valueCustomerNationalCode}
                          index={valueCustomerNationalCode?.length}
                          setChildValue={setChildValueCustomerNationalCode}
                        />
                        <ChipCmp
                          item={valueCustomerName}
                          enamValue={valueCustomerName}
                          index={valueCustomerName?.length}
                          setChildValue={setChildValueCustomerName}
                        />
                        <ChipCmp
                          item={valueReferenceKey}
                          enamValue={valueReferenceKey}
                          index={valueReferenceKey?.length}
                          setChildValue={setChildValueReferenceKey}
                        />
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  ""
                )}
              </form>
            )}
          </Formik>
        </Box>
      ) : (
        ""
      )}
      <br />

      <div className="cardTableBorder ">
        <TableContainer
          style={{ background: "#fff", direction: "rtl" }}
          className={`${data?.length > 0 ? "boxScrollSubmit" : ""}`}
        >
          <Table
            stickyHeader
            aria-label="sticky table "
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
              >
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                  style={{ width: "5px" }}
                >
                  ردیف
                </TableCell>
                {columns?.map((column) => (
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight nowrapClass"
                    key={column.id}
                    align="right"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>

            <TableBody
              style={{
                height: "30px",
                minHeight: "30px",
              }}
            >
              {data?.map((row, rowIndex) => {
                return (
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${
                      rowIndex % 2 == 0
                        ? "rowTBodyE  borderRight borderLeft"
                        : "rowTBodyO  borderRight borderLeft"
                    }${classes} borderRight borderLeft cursorPointer noWrap`}
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    // key={row.loanRequestId}
                    // selected={selectedRow === rowIndex}
                    // onClick={() => handleDetail(row.referenceKey!)}
                  >
                    <TableCell className="textFont12" style={{ width: "5px" }}>
                      {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                        (currentPaginationInfo.pageSize! ?? 0) +
                        rowIndex +
                        1}
                    </TableCell>
                    {columns?.map((column) => {
                      const value =
                        row[column.id as keyof GetSuccessfullPaymentsResponse];
                      return (
                        <TableCell
                          className="textFont12 nowrapClass"
                          key={column.id}
                          align="right"
                        >
                          {column.format && column.hasFormat
                            ? column.format(value)
                            : value instanceof Date
                            ? value.toLocaleString()
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div>
        <Grid container spacing={2} alignItems="center">
          <Grid
            item
            xs={12}
            sm={4}
            display="flex"
            justifyContent={{ xs: "center", sm: "flex-start" }}
          >
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :
              <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
            </span>
          </Grid>
          <Grid item xs={12} sm={4} display="flex" justifyContent="center">
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              // color="primary"
              sx={{
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
              }}
              count={Math.ceil(pageInfo.total / pageInfo.pageSize)}
              onChange={handleChangePagination}
              page={currentPaginationInfo.pageNumber}
            />
          </Grid>
          <Grid item xs={12} sm={4}></Grid>
        </Grid>
      </div>
    </div>
  );
}
